import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { selectCrucialUserDataErrors } from '@/store/selectors/combined.selectors';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

/*
 This hook is responsible for doing the high level error handling if we find some of the imporant business
 user data is missing.
 Because we use certain pieces of user data to determine flows, and sometimes the data doesn't come in, due to a request error,
 we need a way to ensure that if it happens the user doesn't continue using the app before refreshing the data.
 */
export function useIncompleteDataCheck(): void {
  const crucialUserDataErrors = useSelector(selectCrucialUserDataErrors);
  const { openModal } = useModal();

  useEffect(() => {
    if (crucialUserDataErrors.length > 0) {
      openModal(MODALS.INCOMPLETE_USER_DATA);
    }
  }, [crucialUserDataErrors]);
}
